import { useNavigate } from "react-router-dom";

export const HotelInformationList = ({ hotelinfolist = [], hotelInfo = null}) => {

    const navigate = useNavigate();

    //console.log(data);

    const handleNavigate = (id: number) => {
        navigate('/hotel-info/detail/' + id);
    }

    return (
        <div>


            {
                hotelinfolist.length === 1 ? (

                    <>
                        <div className="title-head-hi">
                            {hotelInfo.title}
                        </div>
                        <div className='mt-4' dangerouslySetInnerHTML={{ __html: hotelInfo.hotelInformationLabel[0].description }}></div>
                    </>

                ) :
                    hotelinfolist.map((item, index) => {
                        return (
                            <div key={'hotelinfo' + (index + 1)} className='w-full rounded-md border shadow flex justify-start items-center p-2 mt-4' onClick={() => { handleNavigate(item.id) }}>
                                <img src="assets/img/svg/policy_img2.svg" alt="img 1" width={'94px'} height={'94px'} />
                                <span className='ml-4'>
                                    {item.title}
                                </span>
                            </div>
                        )
                    })
            }


            {
                (hotelinfolist.length < 1) && (<div>Sin información</div>)
            }

        </div>
    );
};
